module.exports = __webpack_public_path__ + "img/B2.e53e6172.png";